

export const BASE_URL = "https://us-central1-trimed-979b9.cloudfunctions.net"; 



// WEBPACK FOOTER //
// ./src/utils/config.js